import { render, staticRenderFns } from "./TicketsFormularioUser.vue?vue&type=template&id=10f354a3&"
import script from "./TicketsFormularioUser.vue?vue&type=script&lang=ts&"
export * from "./TicketsFormularioUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports